import {
    setup,
    gettext,
    isPlural,
    lazyGettext,
    ngettext,
    setLanguage,
} from '@eb/i18n';
import context from './context';

setup(context);

/**
 * Casts return type of given function to `string` while preserving type info of the original signature's parameters
 */
const getRetypedGenericLazyStringFunction = <
    FunctionToRetype extends (...args: any) => any
>(
    functionToRetype: FunctionToRetype,
) =>
    (functionToRetype as unknown) as (
        ...params: Parameters<FunctionToRetype>
    ) => string;

// These 2 functions have to be retyped because GenericLazyString extends String constructor and not string plain type
// and that breaks typechecking of built-in React string properties like __html
const retypedGettext = getRetypedGenericLazyStringFunction(gettext);
const retypedLazyGettext = getRetypedGenericLazyStringFunction(lazyGettext);

export {
    retypedGettext as gettext,
    isPlural,
    retypedLazyGettext as lazyGettext,
    ngettext,
    setLanguage,
};
